import { useQuery } from "react-query";
import API from "../../axios/API";
import { QUERY_KEYS } from "../keys";
import { GET_ENDPOINTS } from "@/axios/API/endpoints";

const getUserData = async () => {
  const { data } = await API.get(GET_ENDPOINTS.USER_DATA);
  return data;
};

const useUserData = () => useQuery(QUERY_KEYS.USER_DATA, getUserData);

export default useUserData;
